module.exports = function() {
  return new Worker(__webpack_public_path__ + "e1e6d98a22791755a0f4.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThreeJS/Geo/GeoWorker.worker.js
// module id = 172
// module chunks = 0